import axios from "axios";
import QueryString from "qs";
import { toast } from "react-hot-toast";
import mainAxios, { updateAxiosToken } from "../api/mainAxios";

// Login Action
export const login = (credentials, navigate) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_ENDPOINT_URL}api/auth/local`,
      {
        identifier: credentials.email,
        password: credentials.password,
      }
    );

    const { jwt, user } = response.data;

    if (jwt) {
      // Set token and user in localStorage
      localStorage.setItem("token", jwt);
      localStorage.setItem("user", JSON.stringify(user));

      // Dispatch success action with user data
      dispatch({ type: "LOGIN_SUCCESS", payload: { user, jwt } });

      // Small delay to ensure token is set before any API calls
      updateAxiosToken();
      setTimeout(() => {
        navigate("/immobilier");
        toast.success("Connexion réussie");
      }, 100);
    } else {
      throw new Error("Problème avec le token");
    }
  } catch (error) {
    console.error("error", error);
    let errorMessage = "Veuillez vérifier votre adresse email ou mot de passe";

    if (error.message) {
      errorMessage = error.message;
    }
    console.error("errorMessage", errorMessage);
    toast.error(
      errorMessage === "Invalid identifier or password" ||
        errorMessage === "Request failed with status code 500"
        ? "Veuillez vérifier votre adresse email ou votre mot de passe"
        : "Une erreur s'est produite lors de la connexion. Veuillez recommencer"
    );
    dispatch({ type: "LOGIN_FAILURE", payload: errorMessage });
  }
};

// Logout Action
export const logout = (navigate) => async (dispatch) => {
  try {
    localStorage.clear();
    dispatch({ type: "LOGOUT" });
    navigate("/login");
  } catch (error) {
    console.error(error);
  }
};

// Fetch User Data Action
export const UserData = () => async (dispatch) => {
  const token = localStorage.getItem("token");

  if (!token) {
    localStorage.clear();
    dispatch({ type: "UNAUTHORIZED" });
    dispatch({ type: "LOGOUT" });
    return;
  }

  // dispatch({ type: "USERS_LOADING" });
  const query = QueryString.stringify({
    populate: {
      profile_image: {
        fields: ["url"]
      },
      search_histories: {
        sort: ["createdAt:desc"],
        populate: "*",
      },
      lots_favoris: {
        populate: {
          images: {
            populate: {
              image: {
                fields: ["url"],
              },
            },
          },
          project_types: {
            fields: ["projectType", "label"],
          },
        },
      },
      secteurs: {
        populate: "*",
      },
      role: {
        fields: ["*"],
      },
      programmes_favoris: {
        populate: {
          images: {
            populate: {
              image: {
                fields: ["url"],
              },
            },
          },
          lots: {
            populate: {
              images: {
                populate: {
                  image: {
                    fields: ["url"],
                  },
                },
              },
            },
          },
        },
      },
    },
  });
  try {
    const response = await mainAxios.get(`api/users/me?${query}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({ type: "USERDATA_SUCCESS", payload: response.data });
  } catch (error) {
    localStorage.clear();
    dispatch({ type: "UNAUTHORIZED" });
    console.error(error);
  }
};

// Rehydrate Auth Action (for persisting state on refresh)
export const rehydrateAuth = () => (dispatch) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  if (token && user) {
    dispatch({ type: "LOGIN_SUCCESS", payload: { user } });
  }
};
